import { Card } from '@material-ui/core';
import React, { ReactNode } from 'react';
import styles from './YoutubeEmbed.scss';
import { getUniqueKey } from '../../utils/KeyUtils';
const rootClassName = styles.rootClassName;

/*
 * Youtube Embed doc: https://developers.google.com/youtube/player_parameters?hl=pt-br#rel
 */

export enum YoutubeEmbedControl {
  Never = 0,
  Always = 1,
  MouseClick = 2
}

export interface IYoutubeEmbedOptions {
  
}

export interface IYoutubeEmbed {
  id: string,
  autoPlay?: boolean,
  controls?: YoutubeEmbedControl,
  endMosaic?: boolean,
  showinfo?: boolean,
  raw?: boolean,
}

export interface IYoutubeEmbedState {

}

class YoutubeEmbed extends React.Component<IYoutubeEmbed, IYoutubeEmbedState> {

  getContainer = (video: ReactNode) => {
    if (this.props.raw) {
      return (
        <div
          className={ rootClassName }
        >
          { video }
        </div>
      )
    }
    return (
      <Card
        className={ rootClassName }
      >
        { video }
      </Card>
    )
  }

  render() {
    const { id, autoPlay, controls, showinfo } = this.props;
    let urlParams: URLSearchParams = new URLSearchParams();
    urlParams.append('fs', '1');
    urlParams.append('iv_load_policy', '3');
    urlParams.append('modestbranding', '1');
    urlParams.append('playsinline', '1');
    urlParams.append('enablejsapi', '1');
    urlParams.append('autoplay', (autoPlay ? 1 : 0).toString());
    urlParams.append('origin', window.location.hostname);
    urlParams.append('rel', '0');
    urlParams.append('controls', (controls === undefined ? YoutubeEmbedControl.MouseClick : controls).toString());
    urlParams.append('showinfo', (showinfo ? 1 : 0).toString());
    urlParams.append('version', '3');
    urlParams.append('color', 'white');
    const url = `https://www.youtube.com/embed/${id}?${urlParams.toString()}`;
    return this.getContainer((
      <iframe
        title={ getUniqueKey() }
        allowFullScreen
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        className={ rootClassName + '-embed' }
        src={ url }
      />
    ))
  }
}

export default YoutubeEmbed;
